import ServiceCard from 'components/services/service-card'
import AdmissionsNotice from 'components/compliance/admissions-notice'
import services from 'data/data.json'
import compliance from 'data/compliance.json'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

function Services() {
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'UHDSS - services'
  }, [])
  return (
    <main id='main' className='mt-5'>
      <section className='pt-5 bg-gradient-light-white mb-3 pb-0'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-12 col-md-10 col-lg-8 text-center' data-aos='fade-up'>
              <span className='badge rounded-pill bg-success-soft mb-3'>
                <span className='h6 text-uppercase'>Flexibility</span>
              </span>

              <h1 className='mb-3 display-6 dark-blue'>Easy and fast services</h1>

              <p className='mb-7 text-start dark-blue fs-5 p-lh mt-4 mb-md-9'>
                We have worked in this field for several years and we prepare applications carefully so that they are not
                delayed by missing documents. How long an admission decision takes is set by the institution and varies
                by country, level and course.
              </p>

              <p className='mb-7 text-start dark-blue fs-5 p-lh mt-4 mb-md-9'>
                We follow up on visa applications and keep you informed, although the time an embassy takes and the
                decision it reaches are entirely matters for that embassy. You can work with us from wherever you are,
                and we give every applicant a unique code so that you can follow the progress of your application
                yourself on our platform.
              </p>

              <AdmissionsNotice className='text-start' />
            </div>

            <div className='row mt-7 my-5'>
              {services.services.map((service, index) => (
                <ServiceCard key={index} service={service} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className='pt-0 pb-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-12 col-md-10 col-lg-9'>
              <h2 className='h3 dark-blue mb-3'>Before we recommend an application</h2>

              <p className='dark-blue fs-6'>
                We do not simply submit as many applications as possible. Before we recommend an institution or a
                programme, we look at your situation so that we can suggest options you have a reasonable basis of
                eligibility for. Depending on the destination and the course, we consider:
              </p>

              <ul className='dark-blue fs-6'>
                {compliance.admissions.suitabilityFactors.map((factor, index) => (
                  <li className='mb-2' key={index}>{factor}</li>
                ))}
              </ul>

              <p className='dark-blue fs-6'>
                This assessment is our guidance, based on the information you give us. It does not replace the formal
                decision of the university, college or immigration authority, and where the requirements matter we will
                point you to the official source.
              </p>

              <h2 className='h3 dark-blue mt-5 mb-3'>What our services cost</h2>

              <p className='dark-blue fs-6'>
                Our{' '}
                <Link className='text-decoration-none' to='/fees'>fees and service charges policy</Link>{' '}
                explains what we provide at no charge to students, how we would tell you about any charge before you
                commit to it, and which costs are set by other organisations. Our{' '}
                <Link className='text-decoration-none' to='/payments'>tuition and student payments policy</Link>{' '}
                explains how tuition, deposits and government fees should be paid.
              </p>

              <p className='dark-blue fs-6'>
                Our{' '}
                <Link className='text-decoration-none' to='/student-commitment'>Student Commitment and Counselling Charter</Link>{' '}
                sets out what you can expect from us at every stage.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>

  )
}

export default Services